// extracted by mini-css-extract-plugin
module.exports = {"timer-indicator":"style_timer-indicator__KE4hM"};